export default __webpack_public_path__ + "img/markup_tools/eraser_tool.svg";